/**
 * Ward Data Model
 * Represents a ward/unit within a facility
 */

export const createWard = (data = {}) => {
  return {
    id: data.id || `WARD-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    facilityId: data.facilityId || null, // Required: links ward to facility
    
    // Basic Information
    name: data.name || '',
    code: data.code || '', // Short code/identifier (e.g., "Ward A", "Room 1")
    type: data.type || 'Room', // 'Room', 'Ward', 'Unit', 'House', 'Apartment', 'Cottage', 'Villa', 'Suite', 'Flat'
    description: data.description || '',
    
    // Capacity & Occupancy
    capacity: data.capacity || 0,
    occupied: data.occupied || 0,
    available: (data.capacity || 0) - (data.occupied || 0),
    occupancyRate: data.capacity > 0 ? ((data.occupied || 0) / data.capacity * 100).toFixed(1) : 0,
    
    // Care Information
    careLevel: data.careLevel || 'Medium', // 'Low', 'Medium', 'High', 'Critical'
    specialization: data.specialization || '', // e.g., 'Dementia & Alzheimer's', 'Palliative Care'
    careType: data.careType || 'general', // 'general', 'memory_care', 'palliative', 'rehabilitation', 'respite'
    
    // Staffing
    staffRatio: data.staffRatio || '1:5', // Staff to resident ratio
    manager: data.manager || '',
    managerId: data.managerId || null,
    totalStaff: data.totalStaff || 0,
    
    // Operational Metrics
    activeAlerts: data.activeAlerts || 0,
    pendingMeds: data.pendingMeds || 0,
    connectedFamilies: data.connectedFamilies || 0,
    automatedWorkflows: data.automatedWorkflows || 0,
    adherenceRate: data.adherenceRate || 0,
    
    // Status
    status: data.status || 'active', // 'active', 'inactive', 'maintenance', 'closed'
    
    // Location/Physical
    floor: data.floor || null,
    building: data.building || null,
    wing: data.wing || null,
    
    // Timestamps
    createdAt: data.createdAt || new Date().toISOString(),
    updatedAt: data.updatedAt || new Date().toISOString()
  };
};

export const WARD_TYPES = {
  UNIT: 'Unit',
  HOUSE: 'House',
  WARD: 'Ward',
  ROOM: 'Room',
  APARTMENT: 'Apartment',
  COTTAGE: 'Cottage',
  VILLA: 'Villa',
  SUITE: 'Suite',
  FLAT: 'Flat'
};

export default {
  createWard,
  WARD_TYPES
};

